<template>
    <div id="reviewOnline">
        <div class="second-header-wrap">
            <el-select size="medium" v-model="currentNotice" @change="noticeChange" placeholder="请选择">
                <el-option
                    v-for="noticeItem in noticeList"
                    :key="noticeItem.id"
                    :label="noticeItem.title"
                    :value="noticeItem.id">
                </el-option>
            </el-select>
            <el-select size="medium" v-model="currentGroup" @change="groupChange" placeholder="请选择">
                <el-option
                    v-for="groupItem in groupList"
                    :key="groupItem.id"
                    :label="groupItem.groupName"
                    :value="groupItem.id">
                </el-option>
            </el-select>
            <el-select size="medium" v-model="currentHomeAddress" @change="homeAddressChange" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option :label="homeAddressItem.value" :value="homeAddressItem.code" v-for="homeAddressItem in homeAddressList"></el-option>
            </el-select>
            <el-input size="medium" style="width: 230px;" v-model.trim="searchVal" placeholder="身份证/护照/学生姓名/招生序号/报名编号" @keyup.enter.native="getGroupApplyStuPageListFunc"></el-input>
            <el-button type="primary" @click="getGroupApplyStuPageListFunc" size="medium">搜索</el-button>
        </div>
        <div class="table-container">
            <el-table
                ref="messageTable"
                :data="dataList"
                class="messageTable custom—scrollbar"
                fit
                style="width: 100%"
                border
            >
                <el-table-column
                    label="报名序号" align="center" prop="orderNo">
                </el-table-column>
                <el-table-column
                    v-if="hasApplyNo"
                    label="报名编号" align="center" show-overflow-tooltip width="120">
                    <template slot-scope="scope">
                        {{scope.row.applyNo}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="姓名" align="center" show-overflow-tooltip width="300">
                    <template slot-scope="scope">
                        <router-link :to="{path: 'reviewQuestionnaireDetail', query: {groupType: currentGroupType, stuId: scope.row.id, groupId: currentGroup, fromOnlineReview: 1, orderNo: scope.row.orderNo, noticeId: currentNotice}}">{{scope.row.stuName}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column
                    label="性别" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.gender === 1 ? '男' : '女'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="身份证/护照号" align="center" prop="idCard">
                </el-table-column>
                <el-table-column
                    label="家长手机号" align="center">
                    <template slot-scope="scope">
                        {{scope.row.loginPhone || scope.row.fatherPhone || scope.row.matherPhone}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="报名时间" align="center">
                    <template slot-scope="scope">
                        {{scope.row.createTime | timeSuffixFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="状态" align="center" prop="state">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state === 8">预录取</span>
                        <span v-else-if="scope.row.state === 0 || scope.row.state === 1">待审核</span>
                        <span v-else-if="scope.row.lineExamState === 1">二审通过</span>
                        <span v-else-if="scope.row.lineExamState === 2">二审不通过</span>
                        <span v-else-if="scope.row.isSameAgree === 1">意见一致，资料无误</span>
                        <span v-else-if=" scope.row.isSameAgree === 2">意见不一致或资料有误</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-container">
            <el-pagination
                @size-change="sizeChangeHandler"
                @current-change="currentChangeHandler"
                :current-page.sync="pagination.pageNo"
                :page-sizes="[10 , 20, 30, 50]"
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :page-count="pagination.pages"
                :total="pagination.total"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>

    import {
        getUserExamineGroupList,
        getGroupApplyStuPageList,
        getExamineNoticeList,
        getSchoolEnrolFieldList
    } from '@/api/primary/review';
    import {
        findSchoolDicsByCode,
    } from '@/api/common';
    import baseMixin from '@/mixins/baseMixin';
    import {mapGetters} from 'vuex';

    export default {
        name: "reviewOnline",
        data() {
            return {
                noticeList: [],
                currentNotice: null,
                groupList: [],
                currentGroup: null,
                dataList: [],
                searchVal: '',
                currentHomeAddress: null,
                homeAddressList: [],
                currentEnrolType: null,
                currentSchoolId: null,
                currentGroupType: null,
                hasApplyNo: false
            }
        },
        mixins: [baseMixin],
        filters: {
            timeSuffixFilter(datetime) {
                return datetime ? datetime.slice(0, datetime.indexOf('.')) : datetime;
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if(from.name === 'ReviewQuestionnaireDetail') {
                    const reviewOnlineMetaStr = sessionStorage.getItem('reviewOnlineMeta');
                    if(reviewOnlineMetaStr) {
                        const reviewOnlineMeta = JSON.parse(reviewOnlineMetaStr);
                        vm.currentNotice = reviewOnlineMeta.currentNotice;
                        vm.currentHomeAddress = reviewOnlineMeta.currentHomeAddress;
                        vm.currentSchoolId = reviewOnlineMeta.currentSchoolId;
                        vm.currentEnrolType = reviewOnlineMeta.currentEnrolType;
                        vm.currentGroup = reviewOnlineMeta.currentGroup;
                        vm.currentGroupType = reviewOnlineMeta.currentGroupType;
                        vm.pagination = {
                            pageSize: parseInt(reviewOnlineMeta.pageSize),
                            pages: 0,
                            total: 0,
                            pageNo: parseInt(reviewOnlineMeta.pageNo),
                        };

                        getExamineNoticeList()
                            .then(res => res.data)
                            .then(data => {
                                vm.noticeList = data.data;
                                if(data.data.length !== 0) {
                                    Promise.all([
                                        vm.getHomeAddressFunc(false),
                                        vm.getUserExamineGroupListFunc(false)
                                    ])
                                        .then(() => {
                                            vm.getGroupApplyStuPageListFunc(false);
                                        });
                                }
                            });
                    }
                } else {
                    sessionStorage.setItem('reviewOnlineMeta', '');
                    getExamineNoticeList()
                        .then(res => res.data)
                        .then(data => {
                            vm.noticeList = data.data;
                            if(data.data.length !== 0) {
                                vm.currentNotice = data.data[0].id;
                                vm.currentEnrolType = data.data[0].enrolType;
                                vm.currentSchoolId = data.data[0].schoolId;
                                Promise.all([
                                    vm.getHomeAddressFunc(),
                                    vm.getUserExamineGroupListFunc()
                                ])
                                    .then(() => {
                                        vm.getGroupApplyStuPageListFunc();
                                    });
                            }
                        })
                }
            });
        },
        beforeRouteLeave (to, from, next) {
            if(to.name === 'ReviewQuestionnaireDetail') {
                sessionStorage.setItem('reviewOnlineMeta', JSON.stringify({
                    currentNotice: this.currentNotice,
                    currentHomeAddress: this.currentHomeAddress,
                    currentSchoolId: this.currentSchoolId,
                    currentEnrolType: this.currentEnrolType,
                    pageSize: this.pagination.pageSize,
                    pageNo: this.pagination.pageNo,
                    pages: this.pagination.pages,
                    currentGroup: this.currentGroup,
                    currentGroupType: this.currentGroupType
                }));
            } else {
                sessionStorage.setItem('reviewOnlineMeta', '');
            }
            next();
        },
        created() {
            const reviewOnlineMetaStr = sessionStorage.getItem('reviewOnlineMeta');
            if(reviewOnlineMetaStr) {
                const reviewOnlineMeta = JSON.parse(reviewOnlineMetaStr);
                this.pagination.pageNo = reviewOnlineMeta.pageNo;
            }
            this.getSchoolEnrolFieldListFunc();

        },
        methods: {
            getSchoolEnrolFieldListFunc(){
                getSchoolEnrolFieldList({
                    yearNo:this.$moment(new Date()).format('YYYY')
                })
                    .then(res=>res.data)
                    .then(data=>{
                        if(data.code===200){
                            this.hasApplyNo = data.data.findIndex(item => item.fieldName === 'applyNo') !== -1;
                        }
                    })
            },
            getHomeAddressFunc(isClear = true) {
                return findSchoolDicsByCode({
                    schoolId: this.currentSchoolId,
                    dicCode: this.currentEnrolType === 1 ? 'primaryTeachAreas' : 'middleTeachAreas'
                })
                    .then(res => res.data)
                    .then(data => {
                        this.homeAddressList = data.data;
                        if(isClear) {
                            this.currentHomeAddress = '';
                        }
                    });
            },
            sizeChangeHandler(pageSize) {
                this.pagination.pageSize = pageSize;
                this.pagination.pageNo = 1;
                this.getGroupApplyStuPageListFunc();
            },
            currentChangeHandler(pageNo) {
                this.pagination.pageNo = pageNo;
                this.getGroupApplyStuPageListFunc();
            },
            getUserExamineGroupListFunc(isClear = true) {
                return getUserExamineGroupList({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        this.groupList = data.data;
                        if(isClear) {
                            this.currentGroup = data.data[0].id;
                            this.currentGroupType = data.data[0].type;
                        }

                    });
            },
            getGroupApplyStuPageListFunc() {
                if(!this.currentGroup){
                    this.currentGroup=0;
                }
                getGroupApplyStuPageList({
                    groupId: this.currentGroup,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    searchVal: this.searchVal,
                    homeAddress: this.currentHomeAddress,
                    state: 0
                })
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.pagination.total = data.data.pagination.total;
                    })
            },
            homeAddressChange() {
                this.searchVal = '';
                this.getGroupApplyStuPageListFunc();
            },
            groupChange() {
                this.searchVal = '';
                this.currentGroupType = this.groupList.find(item => item.id === this.currentGroup).type;
                this.getGroupApplyStuPageListFunc();
            },
            noticeChange() {
                this.searchVal = '';
                const noticeItem = this.noticeList.find(({id}) => id === this.currentNotice);
                this.currentNotice = noticeItem.id;
                this.currentEnrolType = noticeItem.enrolType;
                this.currentSchoolId = noticeItem.schoolId;
                Promise.all([
                    this.getHomeAddressFunc(),
                    this.getUserExamineGroupListFunc()
                ])
                    .then(() => {
                        this.getGroupApplyStuPageListFunc();
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";
    @include globalstyle;

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 0;
        background-color: #fff;
        z-index: 1000;
    }
    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 0;
    }
</style>
<style>
    #reviewOnline a {
        color: #409EFF;
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/review/ReviewOnline.vue